import React, { useState, useEffect } from 'react';
import { faFileAlt, faPencilAlt, faImage, faSave } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';

//Components
import MainCard from 'components/MainCard/MainCard';
import Loading from 'components/Loading/Loading';
import TextField from 'components/TextField/TextField';


//Api
import vistoria_api from '../../../../api/solicitacaoVistoria_api';
import solicitacaoVistoria_api from '../../../../api/solicitacaoVistoria_api';
import usuario_api from '../../../../api/usuario_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { validarCampos, objCampo, PrintValidate } from '../../../../helpers/ValidadorDeCampos';

export default function FichaAgendamento({ btnVoltar, editarAgendamento }) {
    //Estado de controle dos dados do agendamento
    const [agendamento, setAgendamento] = useState({
        tbUsuario_Id: null,
        dataAgendamento: null,
        observacoes: null,
        status: null,
        avulsa: null,
        resultado: null,
        tbSolicitacaoVistoria_Id: editarAgendamento.solicitacaoVistoriaId,
        id: editarAgendamento.id
    });

    //Estado de controle dos dados da vistoria
    const [vistoria, setVistoria] = useState();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado que guarda as opções dos fiscais
    const [optionsFiscais, setOptionsFiscais] = useState([]);

    //Estado que guarda os erros no agendamento
    const [errorsAgendamento, setErrorsAgendamento] = useState({});

    //Campos obrigatorios para cadastrar o agendamento
    const camposAgendamento = [
        objCampo({ name: "tbUsuario_Id", required: true }),
        objCampo({ name: "dataAgendamento", required: true }),
        objCampo({ name: "observacoes", required: true }),
    ]


    //Carrega os dados do agendamento
    useEffect(() => {
        setLoading(true);
        vistoria_api.GetItem(editarAgendamento.solicitacaoVistoriaId).then(response => {

            setVistoria(response.data);
            loadFiscais(response.data.tbSetores_Id)
            setAgendamento(prevState => ({
                ...prevState,
                status: response.data.agendamentos.filter(a => a.id == editarAgendamento.id)[0].status,
                avulsa: response.data.agendamentos.filter(a => a.id == editarAgendamento.id)[0].avulsa,
                resultado: response.data.agendamentos.filter(a => a.id == editarAgendamento.id)[0].resultado,
                tbSolicitacaoVistoria_Id: response.data.agendamentos.filter(a => a.id == editarAgendamento.id)[0].tbSolicitacaoVistoria_Id,
                id: response.data.agendamentos.filter(a => a.id == editarAgendamento.id)[0].id,
                tbUsuario_Id: response.data.agendamentos.filter(a => a.id == editarAgendamento.id)[0].tbUsuario_Id
            }));
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }, [])

    //Função que carrega os fiscais
    const loadFiscais = (setorId) => {
        usuario_api.getListByPerfil("Fiscal", setorId).then(response => {
            setOptionsFiscais([...response.data.map(value => { return { label: value.nome, value: value.id.toString() } })]);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Função de onChange dos campos de agendamento
    const onChangeAgendamento = (e) => {
        const { name, value } = e.target;
        const _agendamento = {
            ...agendamento,
            [name]: value
        };
        setAgendamento(_agendamento);
    }

    //Função de onChange do campo de fiscal do agendamento
    const onChangeFiscalAgendamento = (e, select) => {
        setAgendamento({
            ...agendamento,
            [select.name]: e && e.value ? e.value : "",
            fiscal: e && e.value ? e.label : ""
        })
    }

    //Função que salva o agendamento a lista
    const salvarAgendamento = () => {
        const _errors = validarCampos(agendamento, camposAgendamento);

        setErrorsAgendamento({ ..._errors[0] })
        if (_errors[1].length > 0) {
            return;
        }
        setLoading(true);

        const novaVistoria = { ...vistoria };
        const index = novaVistoria.agendamentos.findIndex(item => item.id == editarAgendamento.id);

        if (index !== -1) {
            novaVistoria.agendamentos[index] = agendamento; // Substitui o agendamento existente pelo novo
        } else {
            novaVistoria.agendamentos.push(agendamento); // Adiciona o novo agendamento se não existir na lista
        }

        setVistoria(novaVistoria);
        solicitacaoVistoria_api.Put(novaVistoria).then(response => {
            showMessage("Sucesso", "Sucesso ao atualizar a solicitação", "success", btnVoltar);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    return (
        <MainCard btnVoltar={btnVoltar}>
            {loading && <Loading />}
            <div style={{ color: "#666" }}>
                {loading && <Loading />}
                <h2 className='fw-bold text-center my-3'>{ }</h2>
                <h5 style={{ color: "#fff" }} className='p-2 rounded-3 bg-gradient bg-primary d-flex justify-content-between align-items-center'> <span><FontAwesomeIcon icon={faFileAlt} className={"me-3"} />Identificação do Agendamento</span> </h5>
                <Row>
                    <Col md="12" lg="4">
                        <TextField 
                            options={optionsFiscais} 
                            label={"* Fiscal"} 
                            type="select" 
                            name="tbUsuario_Id" 
                            invalid={!!errorsAgendamento.tbUsuario_Id} 
                            value={agendamento.tbUsuario_Id == null ? optionsFiscais.filter(f => f.value == agendamento.tbUsuario_Id)[0] : optionsFiscais.filter(v => v.value == agendamento?.tbUsuario_Id)[0]} 
                            onChange={onChangeFiscalAgendamento} 
                            onBlur={onChangeFiscalAgendamento}
                            searchable 
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField
                            label={"* Data de agendamento"}
                            type="date"
                            name="dataAgendamento"
                            invalid={!!errorsAgendamento.dataAgendamento}
                            value={agendamento.dataAgendamento == null ? moment(vistoria?.agendamentos.filter((a) => a.id = editarAgendamento.id).dataAgendamento).format("YYYY-MM-DD") : agendamento.dataAgendamento}
                            onChange={onChangeAgendamento}
                            onBlur={onChangeAgendamento}
                        />
                    </Col>
                    <Col md="12" lg="4">
                        <TextField 
                            label={"* Observações"} 
                            name="observacoes" 
                            invalid={!!errorsAgendamento.observacoes} 
                            value={agendamento?.observacoes == null ? vistoria?.agendamentos.filter(a => a.id = editarAgendamento.id)[0].observacoes : agendamento.observacoes} 
                            onChange={onChangeAgendamento}
                            onBlur={onChangeAgendamento}
                        />
                    </Col>
                    <div className='d-flex align-items-center justify-content-center mt-3 mb-3'>
                        <Button color={'success'} onClick={salvarAgendamento}  >{<><FontAwesomeIcon icon={faSave} /> Salvar</>} </Button>
                    </div>
                </Row>
            </div>
        </MainCard>
    )
}